import { NgIf, NgClass, NgFor } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Util } from 'app/models/util';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime, distinctUntilChanged, switchMap, of, Subscription } from 'rxjs';
import { RagService } from 'app/services/rag.service';
import { SessionListItem } from 'app/models/copilot.model';

@Component({
  selector: 'modal-search-chats',
  templateUrl: './search-chats.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    NgClass,
    NgFor,
    MatProgressSpinnerModule],
  styleUrl: './search-chats.component.scss'
})
export class SearchChatsComponent implements OnInit {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  chats: SessionListItem[] = [];
  private searchSubject = new Subject<string>();
  private sub = new Subscription();
  query = '';
  loading = false;

  /**
   * Constructor
   */
  constructor(
    public matDialogRef: MatDialogRef<SearchChatsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public util: Util,
    public toastr: ToastrService,
    public rag_service: RagService,

  ) {
    // Debounced search stream
    this.sub.add(
      this.searchSubject
        .pipe(
          debounceTime(400), // wait 400ms after user stops typing
          distinctUntilChanged(),
          switchMap((query) => {
            if (!query.trim()) return of([]); // empty search
            this.loading = true;
            return this.rag_service.searchAssetSessions(this.data.assetId, query).then((res) => {
              this.chats = this.rag_service.getData(res);
              return this.chats;
            });
          })
        )
        .subscribe({
          next: (res) => {
            this.chats = res;
            this.loading = false;
          },
          error: () => {
            this.chats = [];
            this.loading = false;
          },
        })
    );
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void { }

  ngAfterViewInit() {
    setTimeout(() => this.searchInput.nativeElement.focus(), 100);
  }

  // Methods

  onSearchChange() {
    this.searchSubject.next(this.query);
  }

  selectChat(chat: SessionListItem) {
    this.matDialogRef.close(chat);
  }

  close() {
    this.matDialogRef.close();
  }

  clear() {
    this.query = '';
    this.chats = [];
    this.searchInput.nativeElement.focus();
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.close();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
